import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const PayInvoiceWithSavedMethodMutation = graphql.persisted(
  "PayInvoiceWithSavedMethod",
  graphql(`
    mutation PayInvoiceWithSavedMethod($input: PayInvoiceWithSavedMethodInput!) {
      payInvoiceWithSavedMethod(input: $input) {
        success
        status
        chargedCents
        userErrors { message path }
      }
    }
  `)
);

export { PayInvoiceWithSavedMethodMutation };

export function usePayInvoiceWithSavedMethod() {
  return useMutation(PayInvoiceWithSavedMethodMutation);
}
